import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const AuthContext = createContext(null);

const ax = axios.create({ baseURL: '', withCredentials: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await ax.get('/api/auth/me');
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = useCallback(async (email, password) => {
    const { data } = await ax.post('/api/auth/login', { email, password });
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const { data } = await ax.post('/api/auth/register', { email, password, name });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    await ax.post('/api/auth/logout');
    setUser(false);
  }, []);

  const value = useMemo(() => ({
    user, loading, login, register, logout,
    isAdmin: user && user.role === 'admin',
  }), [user, loading, login, register, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { ax };
